import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominaTimbresListaComponent {
  filtro = {}
  data = []
  resultados = []
  seleccionados = []
  seleccionable = false
  todosSeleccionados = false
  onSelect = null
  estatus = [
    {id: 0, descripcion: 'Pago pendiente'},
    {id: 1, descripcion: 'Timbrado Pendiente'},
    {id: 2, descripcion: 'Completado'},
    {id: 3, descripcion: 'Cancelación en proceso'},
  ]

  constructor ($filter) {
    this.filterBy = $filter('filter')
    this.orderBy = $filter('orderBy')
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data.forEach((item) => (item.estatus = NominaTimbresListaComponent.obtenerEstatus(item)))

      this.data = this.orderBy(this.data, ['-status_pagado', 'empleado'])
      this.filtrar(this.filtro)
      this.seleccionar()
    }
  }

  filtrar (filtro) {
    this.filtro = filtro || {}
    this.resultados = this.filterBy(this.data, this.filtro)
    this.ocultos = this.data.length - this.resultados.length

    this.totalizar()
  }

  seleccionar () {
    this.seleccionados = this.data.filter((item) => item.$$seleccionado)

    this.onSelect({$event: {data: this.seleccionados}})
  }

  seleccionarItem (item) {
    item.$$seleccionado = !item.pendiente && item.status_pagado && !item.$$seleccionado && !item.bloqueado

    this.seleccionar()
    this.totalizar()
  }

  seleccionarItems (todos) {
    if (!this.seleccionable) return

    this.resultados.forEach((item) => (item.$$seleccionado = !item.bloqueado && item.status_pagado && todos))

    this.seleccionar()
    this.totalizar()
  }

  totalizar () {
    this.seleccionable = this.resultados.some((item) => !this.bloqueado && item.status_pagado)
    this.todosSeleccionados = this.resultados.every((item) => item.bloqueado || !item.status_pagado || item.$$seleccionado)
  }

  static obtenerEstatus (item) {
    if (!item.status_pagado) {// Pago pendiente
      return 0
    } else if (!item.status_timbrado) {// Pendiente por timbrar
      return 1
    } else if (item.status_cancelacion) {// Timbrado en proceso de cancelación
      return 3
    } else {// Timbrado completado
      return 2
    }
  }
}

module.component('nominaTimbresLista', {
  controller: NominaTimbresListaComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    data: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/lista/component.js